export const AUTHENTICATED = "AUTHENTICATED";
export const LOGOUT = "LOGOUT";
export const SET_USER = "SET_USER";
